export enum FieldValueConstants {
  IDontKnow = "I don't know",
}
